import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatSelectModule } from '@angular/material/select'
import { FormsModule } from '@angular/forms'
import { TranslationService } from '../../../../services/translation.service'

import { UserService } from '../../../../services/user.service'
import { SpinnerService } from '../../../../services/spinner.service'
import { CANADIAN_PROVINCES } from '../../../../constants/provinces'
import { LocationService } from '../../../../services/location.service'
import { LocationInLS } from '../../../../types/locations'
import {
  CanadianProvinceName,
  RecyclabilityCountry,
} from '../../../../types/recyclability'
import { RECYCLABILITY_COUNTRIES } from '../../../../constants/country-recyclability'

type DATA = {
  title: string
  message: string
}

type Province = {
  name: string
}
@Component({
  selector: 'app-location-dialog',
  imports: [MatButtonModule, MatIconModule, MatSelectModule, FormsModule],
  templateUrl: './location-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './location-dialog.component.scss',
})
export class LocationDialogComponent implements OnInit {
  dialogRef = inject<DialogRef<string>>(DialogRef)
  data = inject<DATA>(DIALOG_DATA)
  translationService = inject(TranslationService)
  private userService = inject(UserService)
  private spinnerService = inject(SpinnerService)
  private locationService = inject(LocationService)

  public countries: Array<RecyclabilityCountry> = [...RECYCLABILITY_COUNTRIES]
  public selectedCountry: RecyclabilityCountry | null = null

  public provinces: Province[] = [...CANADIAN_PROVINCES]
  public selectedProvince: CanadianProvinceName | null = null

  constructor() {
    const locationService = this.locationService

    const lsLocation = locationService.getLocationFromLS()
    if (lsLocation) {
      this.selectedProvince = lsLocation.province
    }
  }

  async ngOnInit(): Promise<void> {
    try {
      this.spinnerService.startSpinner()
      const userLocation = this.locationService.getLocationFromLS()
      if (!userLocation) {
        return
      }
      this.selectedCountry = userLocation.country
      this.selectedProvince = userLocation.province
    } finally {
      this.spinnerService.stopSpinner()
    }
  }

  async submitLocation() {
    if (this.selectedCountry) {
      if (!this.isCanada()) {
        this.selectedProvince = null
      }

      try {
        this.spinnerService.startSpinner()
        const now = new Date()
        const locationForLS: LocationInLS = {
          country: this.selectedCountry,
          expiry: now.getTime() + 7 * 24 * 60 * 60 * 1000,
          province: this.selectedProvince,
        }
        this.locationService.storeLocationInLS(locationForLS)
      } finally {
        this.spinnerService.stopSpinner()
        this.dialogRef.close()
      }
    }
  }

  isCanada(): boolean {
    return this.selectedCountry === 'Canada'
  }
}
